export default __webpack_public_path__ + "static/media/g.aca44fd7.jpg";